import "./index.css";

import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App.js";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
